<template>
  <UiSheet class="ui-footer">
    <UiContainer class="pb-8 pt-8 px-6">
      <UiRow align="center">
        <UiCol cols="auto" class="ui-footer__logo">
          <slot name="logo" />
        </UiCol>
        <UiSpacer />
        <UiCol cols="auto">
          <slot name="socials" />
        </UiCol>
      </UiRow>
      <UiDivider class="mt-6 mb-8 ui-footer__divider" />
      <UiRow justify="space-between">
        <UiCol order="2" order-sm="1" cols="12" sm="auto" class="text-body-3">
          <slot name="copyright" />
        </UiCol>
        <UiCol order="1" order-sm="3" cols="12" sm="auto">
          <UiRow align="center" class="d-flex align-center text-body-3 ma-n2">
            <slot name="links" />
          </UiRow>
        </UiCol>
      </UiRow>
    </UiContainer>
  </UiSheet>
</template>

<script setup lang="ts">
import UiSheet from '../UiSheet/UiSheet.vue';
import UiSpacer from '../UiSpacer/UiSpacer.vue';
import { UiRow, UiCol, UiContainer, UiDivider } from '~/ui';
</script>

<style lang="scss" scoped>
.ui-footer {
  border-top: 1px solid rgb(var(--v-theme-footer-border-color));
  background-color: rgb(var(--v-theme-footer-bg-color));
  color: rgb(var(--v-theme-footer-text-color));

  &__divider {
    color: rgb(var(--v-theme-footer-divider-color));
  }

  &__logo {
    color: rgb(var(--v-theme-footer-logo-color));
    display: flex;
  }
}
</style>
